import activeItem from './activeItem';
import dataProperties from './dataProperties';
import filters from './filters';
import pagination from './pagination';
import search from './search';
import selection from './selection';
import sorting from './sorting';
import views from './views';

export default {
  activeItem,
  dataProperties,
  filters,
  pagination,
  search,
  selection,
  sorting,
  views,
};
